<style lang="scss" scoped>
</style>
<template lang="pug">
</template>
<script>
import gql from "graphql-tag";

export default {
	apollo: {
		region: {
			query: gql`
				{
					DetectRegion {
						region_code
					}
				}
			`,
			update: r => {
				localStorage.setItem("graphql-region", r.DetectRegion.region_code);
			},
			result() {
				window.location.replace("/");
			}
		}
	}
};
</script>